export default function isTrue(value) {
    var acceptable = ['true', 1, '1', true];
    if (typeof value === 'string') {
        value = value.toLowerCase();
    }
    return acceptable.includes(value);
}
